var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",attrs:{"src":_vm.video,"controls":"","muted":"muted"},domProps:{"muted":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }